import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  border-radius: 10px;
  background: ${({ theme }) => theme.colors?.backgroundColor};
  border: 1px solid ${({ theme }) => theme.colors?.gray03};
  margin-bottom: 2rem;
`;

export const FieldsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1rem;

  @media screen and (max-width: ${({ theme }) => theme.size?.xlarge}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media screen and (max-width: ${({ theme }) => theme.size?.medium}) {
    grid-template-columns: 1fr;
  }
`;

export const ButtonDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding-top: 1.5rem;
  gap: 1rem;

  @media screen and (max-width: ${({ theme }) => theme.size?.medium}) {
    flex-direction: column;
  }
`;
